import { BridgedCard as Card } from 'components/common/bridged-card';
import { FormattedMessage } from 'react-intl';
import { useVcsRepositoriesSearch } from './use-vcs-repositories-search.hook';
import type { VcsApi } from '@env0/vcs-service/api';
import { useModal } from 'hooks/modal.hooks';
import Modal from 'components/common/modal';
import { Col, Row } from 'components/common/grid';
import { VcsConnectionsModalConnectionDetails } from 'components/organizations/vcs/vcs-connection-modal/vcs-connection-modal-connection-details';
import VcsRepositorySelector, { type VcsRepositorySelectProps } from './vcs-repository-selector';
import Button from 'components/common/button';
import Tooltip from 'components/common/tooltip';
import styled from 'types/theme.types';
import withLabel from 'components/common/form-controlled/with-label.hoc';
import { useHasPermission } from 'hooks/use-has-permission';

export interface VcsRepositoryOauthSelectorProps {
  vcsType: VcsApi.VcsType;
  form: VcsRepositorySelectProps['form'];
}

const VcsRepositoryOauthSelector: React.FC<VcsRepositoryOauthSelectorProps> = ({ vcsType, form }) => {
  const {
    data,
    isFetching: isFetchingRepositories,
    onSearch
  } = useVcsRepositoriesSearch(vcsType, 'DeploymentPipeline');
  const { isAuthorized: canManageVcsConnections } = useHasPermission('MANAGE_VCS_CONNECTIONS');
  const { hideModal, showModal, isModalOpen } = useModal();

  const newConnection = { type: vcsType, connectionType: 'DeploymentPipeline' as const };

  const addButton = (
    <AddConnectionButton onClick={showModal} type="primary" size="small" disabled={!canManageVcsConnections}>
      <FormattedMessage id="vcs.add-button" />
    </AddConnectionButton>
  );

  return (
    <>
      <VcsRepositorySelector
        form={form}
        data={data}
        loading={isFetchingRepositories}
        onSearch={onSearch}
        customActions={
          !canManageVcsConnections ? (
            <Tooltip titleId="permissions.missing.manage-vcs-connections" placement="left">
              <span>{addButton}</span>
            </Tooltip>
          ) : (
            addButton
          )
        }
      />
      <Modal
        open={isModalOpen}
        onCancel={hideModal}
        titleId={`organization.settings.agents.vcs-connections-modal.connection.title`}
        footer={null}
        destroyOnClose={true}
        centered>
        <Card
          title={
            <Row gutter={8}>
              <Col span={5}>
                <FormattedMessage id="organization.settings.agents.vcs-connections-modal.connection.title" />
              </Col>
            </Row>
          }>
          <VcsConnectionsModalConnectionDetails
            vcsConnection={newConnection}
            onSubmit={() => {}}
            hideModal={hideModal}
          />
        </Card>
      </Modal>
    </>
  );
};

const AddConnectionButton = styled(Button)``;

export default withLabel(VcsRepositoryOauthSelector);
